import StripeCallback from './StripeCallback';

export default StripeCallback;
